import TripDaysThresholdListPage from "./list/index.page";

export const tripDaysThresholdPageRouteName = "/config/trip-days-threshold";

const TripDaysThresholdPage = () => {
  return <TripDaysThresholdListPage />;
};

export default TripDaysThresholdPage;
